class EventConstant {
}
// Event types
EventConstant.TYPE_WORKSHOP = '1';
EventConstant.TYPE_WEBCAST = '2';
EventConstant.TYPE_SESSIONS = '3';
// event status codes
EventConstant.STATUS_DRAFTING = '1';
EventConstant.STATUS_ACTIVE = '2';
EventConstant.STATUS_HIDDEN = '3';
EventConstant.STATUS_FULL = '4';
EventConstant.STATUS_DISABLED = '5';
EventConstant.STATUS_CANCELLED = '6';
EventConstant.STATUS_FINALIZED = '7';
// registration status codes
EventConstant.REGISTRATION_ACTIVE = '1';
EventConstant.REGISTRATION_WAITING = '2';
EventConstant.REGISTRATION_CANCELLED = '3';
EventConstant.REGISTRATION_ATTENDED = '4';
// timeslot status codes
EventConstant.TIMESLOT_AVAILABLE = '1';
EventConstant.TIMESLOT_FILLED = '2';
EventConstant.TIMESLOT_RESERVED = '3';
EventConstant.TIMESLOT_HOLDING = '4';
// email types
EventConstant.EMAIL_REGISTRATION = '1';
EventConstant.EMAIL_CANCELLATION = '2';
EventConstant.EMAIL_REMINDER = '3';
EventConstant.EMAIL_FOLLOWUP = '4';
EventConstant.EMAIL_WAITLIST = '5'; // registration for waiting list
EventConstant.EMAIL_WAITLIST_UPGRADE = '6'; // upgrade from waiting list to actual registration
EventConstant.EMAIL_FOLLOWUP_SURVEY = '7'; // Followup survey email
EventConstant.EMAIL_BEHAVIOR_SURVEY = '8'; // behavior change survey email
export { EventConstant };
//# sourceMappingURL=eventConstants.js.map